(() => {
    "use strict";

    const ROTATE_MS = 7000;
    let rotateTimer = null;
    let observer = null;

    function prefersReducedMotion() {
        return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function stopRotation() {
        if (rotateTimer !== null) {
            window.clearInterval(rotateTimer);
            rotateTimer = null;
        }
    }

    function showBlock(root, index) {
        const blocks = [...root.querySelectorAll("[data-clientes-block]")];
        if (!blocks.length) {
            return;
        }
        const nextIndex = ((index % blocks.length) + blocks.length) % blocks.length;
        blocks.forEach((block, blockIndex) => {
            const active = blockIndex === nextIndex;
            block.classList.toggle("is-active", active);
            block.hidden = !active;
            block.setAttribute("aria-hidden", active ? "false" : "true");
        });
        root.dataset.activeBlock = String(nextIndex);
    }

    function boot() {
        observer?.disconnect();
        observer = null;
        stopRotation();

        const root = document.querySelector("[data-clientes-site-grid]");
        if (!root) {
            return;
        }

        const totalBlocks = Number(root.dataset.clientesBlocks || "0");
        const previous = root.querySelector("[data-clientes-prev]");
        const next = root.querySelector("[data-clientes-next]");
        let activeIndex = Number(root.dataset.activeBlock || "0");

        const goTo = (index) => {
            activeIndex = ((index % totalBlocks) + totalBlocks) % totalBlocks;
            showBlock(root, activeIndex);
        };

        previous?.addEventListener("click", () => {
            stopRotation();
            goTo(activeIndex - 1);
        });

        next?.addEventListener("click", () => {
            stopRotation();
            goTo(activeIndex + 1);
        });

        if (totalBlocks <= 1 || prefersReducedMotion()) {
            return;
        }

        if ("IntersectionObserver" in window) {
            observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.target !== root) {
                        return;
                    }
                    if (entry.isIntersecting) {
                        if (rotateTimer === null) {
                            rotateTimer = window.setInterval(() => {
                                goTo(activeIndex + 1);
                            }, ROTATE_MS);
                        }
                        return;
                    }
                    stopRotation();
                });
            }, { threshold: 0.2 });
            observer.observe(root);
            return;
        }

        rotateTimer = window.setInterval(() => {
            goTo(activeIndex + 1);
        }, ROTATE_MS);
    }

    window.siteReady(boot);
})();
